<template>
  <div>
    <div class="shortcutTitle">
      <button tabindex="0" style="cursor: pointer">
              <div class="arrow-icon"  v-html="!isKeysShow? SVG.DOWN_ARROW_SVG : SVG.UP_ARROW_SVG "> </div>

      </button>

      <span class="vjs-menu-title">{{ $t('modals.keyboardShortcuts') }}</span>
    </div>
    <div class="ShortcutsSection" :class="{ 'keys-hidden': isKeysShow }">
      <table>
        <caption></caption>
        <tbody>
          <tr class="HeaderHelpMenu">
            <th id="TextHelpKey" class="LeftTable">{{ $t('modals.functions') }}</th>
            <th id="TextHelpDesc" class="RightTable">{{ $t('modals.shortcuts') }}</th>
          </tr>
          <tr class="ContentHelpMenu">
            <td id="TextHelpArrowMaj" class="LeftTable">
              <div>{{ $t('player.play') }} / {{ $t('player.pause') }}</div>
            </td>
            <td id="TextHelpDescArrowMaj" class="RightTable">
              <span class="help-btn help-btn-lg">{{ $t('AllTraslation.spaceBar') }}</span>
            </td>
          </tr>
          <tr class="ContentHelpMenu">
            <td id="TextHelpKeyLeft" class="LeftTable">
              <div>{{ $t('player.fullscreen') }}</div>
            </td>
            <td id="TextHelpDescLeft" class="RightTable">
              <span class="help-btn">F</span> |
              <span class="help-btn">Ctrl</span> +
              <span class="help-btn">Entrer ↲</span>
            </td>
          </tr>
          <tr class="ContentHelpMenu">
            <td id="TextHelpKeyLeftMaj" class="LeftTable">
              <div>{{ $t('player.adjustVol') }}</div>
            </td>
            <td id="TextHelpDescLeftMaj" class="RightTable">
              <span class="help-btn">⇧</span> |
              <span class="help-btn">⇩</span>
            </td>
          </tr>
          <tr class="ContentHelpMenu" v-if="isDvr || !isLive">
            <td id="TextHelpKeyHaut" class="LeftTable">
              <div>{{ $t('buttons.seekForward') }} / {{ $t('buttons.seekBackward') }}</div>
            </td>
            <td id="TextHelpDescHaut" class="RightTable">
              <span class="help-btn">⇦</span> |
              <span class="help-btn">⇨</span>
            </td>
          </tr>
          <tr class="ContentHelpMenu" v-if="isDvr || !isLive">
            <td id="TextHelpKeyBas" class="LeftTable">
              <div>{{ $t('player.advance') }} / {{ $t('player.fastBackward') }}</div>
            </td>
            <td id="TextHelpDescBas" class="RightTable">
              <span class="help-btn">⇦</span> |
              <span class="help-btn">⇨</span> +
              <span class="help-btn">MAJ</span>
            </td>
          </tr>
          <tr class="ContentHelpMenu">
            <td id="TextHelpKeyO" class="LeftTable">
              <div>{{ $t('interactivity.options') }}</div>
            </td>
            <td id="TextHelpDescO" class="RightTable">
              <span class="help-btn">O</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script >
import { defineComponent } from "vue";
import en from '../../../../../i18n/en_US'
import fr from '../../../../../i18n/fr_FR'
import {SVG} from '../../../../../components/utils/const'

export default defineComponent({
  name: "ShortcutSection",
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  components: {},
  props: {
    isKeysShow: {
      type: Boolean,
    },
    isDvr: {
      type: Boolean,
    },
    isLive:{
      type: Boolean
    }
  },
  data (){
    return {
      SVG:SVG
    }
  }
});
</script>

<style>
.shortcutTitle {
  display: flex;
  align-items: center;
}

.shortcutKey {
  font-size: 12px;
  text-align: center;
  color: var(--vm-color-three-08);
  display: flex;
  justify-content: center;
}

.shortcuts {
  height: 20px;
  width: 55px;
  margin: 1px 7px 0px 4px;
  border-radius: 2px;
  background-color: var(--vm-color-three);
}

.arrow-icon {
  width: 1.5em;
  margin-right: 0.33em;
}

.littleShortcuts {
  width: 24px;
}

.ShortcutsSection {
  margin: 0;
}

.ShortcutsSection.keys-hidden {
  display: none;
}

.shortcutsAlign {
  text-align: right;
}

.scale_100 {
  max-height: 416px !important;
}

.vjs-menu-content .LeftTable {
  text-align: right;
  padding: 3px 21px 3px 0;
}

.vjs-menu-content .RightTable {
  text-align: left;
  padding: 3px 21px 3px 0;
}

.vjs-menu-content .help-btn {
  border: 1px solid var(--vm-color-three);
  padding: 0.4em 1em;
  border-radius: 0.25em;
  margin: 0.2em;
  display: inline-block;
}

@keyframes breathing {
  0% {
    transform: scale(0.9);
  }

  25% {
    transform: scale(1.1);
  }

  60% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(0.9);
  }
}
</style>
